import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_3M_79_3M_19_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_3m_79_3m_19_99_usd',
			EUR: 'simple_premium_3m_79_3m_19_99_eur',
			AUD: 'simple_premium_3m_129_3m_29_99_aud',
			CAD: 'simple_premium_3m_129_3m_29_99_cad',
			GBP: 'simple_premium_3m_79_3m_19_99_gbp',
			DKK: 'simple_premium_3m_679_3m_159_dkk',
			NOK: 'simple_premium_3m_1039_3m_259_nok',
			SEK: 'simple_premium_3m_1039_3m_259_sek',
			TRY: 'simple_premium_3m_2569_3m_649_try',
			BRL: 'simple_premium_3m_319_3m_79_brl',
			MXN: 'simple_premium_3m_1299_3m_319_mxn',
			ARS: 'simple_premium_3m_105389_3m_26669_ars',
			COP: 'simple_premium_3m_315999_3m_79959_cop',
			CLP: 'simple_premium_3m_79000_3m_19990_clp',
		},
		primer: 'prd_kvFfWmOs3D4D',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 19.99,
			EUR: 19.99,
			AUD: 29.99,
			CAD: 29.99,
			GBP: 19.99,
			DKK: 159,
			NOK: 259,
			SEK: 259,
			TRY: 649,
			BRL: 79,
			MXN: 319,
			ARS: 26669,
			COP: 79959,
			CLP: 19990,
		},
		originalPriceMap: {
			USD: 79,
			EUR: 79,
			AUD: 129,
			CAD: 129,
			GBP: 79,
			DKK: 679,
			NOK: 1039,
			SEK: 1039,
			TRY: 2569,
			BRL: 319,
			MXN: 1299,
			ARS: 105389,
			COP: 315999,
			CLP: 79000,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 79,
			EUR: 79,
			AUD: 129,
			CAD: 129,
			GBP: 79,
			DKK: 679,
			NOK: 1039,
			SEK: 1039,
			TRY: 2569,
			BRL: 319,
			MXN: 1299,
			ARS: 105389,
			COP: 315999,
			CLP: 79000,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.90_days.into_period_text'), // 'first quarter'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.90_days.sub_period_text'), // 'quarterly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.90_days.into_period_text'), // 'three months'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.90_days.period_text'), // '3-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.90_days.sub_period_text'), // '3-month'
	}),
}
